module.exports = __webpack_public_path__ + "img/introduce.94db84f8.png";